import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../../global';
import { environment } from '../../../environments/environment';
import { JobOrderInfoRequest, JobOrderInfoResponse, JobOrderApprover, JobOrderRep } from '../models/job-order-info.model';

@Injectable({
  providedIn: 'root'
})
export class JobOrderInfoService {
  private apiUrl = environment.useApiGateway
    ? `${environment.apiGatewayUrl}/joborderinfo`
    : `${GlobalVariable.BASE_URL}/JobOrderInfo`;

  constructor(private http: HttpClient) { }

  getJobOrderInfo(jobOrderId: number): Observable<JobOrderInfoResponse> {
    return this.http.get<JobOrderInfoResponse>(`${this.apiUrl}/${jobOrderId}`);
  }

  downloadLedgerExcel(jobOrderId: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${jobOrderId}/ledger-excel`, {
      responseType: 'blob'
    });
  }

  downloadLedgerPdf(jobOrderId: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${jobOrderId}/ledger-pdf`, {
      responseType: 'blob'
    });
  }

  resetPassword(userId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset-password`, { userId });
  }

  resetEmail(userId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset-email`, { userId });
  }

  updateEmail(userId: number, email: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/update-email`, { userId, email });
  }

  sendPasswordReminder(userId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/send-reminder`, { userId });
  }

  getReps(jobOrderId: number): Observable<JobOrderRep[]> {
    return this.http.get<JobOrderRep[]>(`${this.apiUrl}/${jobOrderId}/reps`);
  }
}
